import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
  errorTitle = 'Error';
  errorDescription = 'Se ha producido un error.';
  showButton = false;
  textButton = '';
  pathButton = '';

  constructor(private _router: Router, private activatedRoute: ActivatedRoute) {
    const state = this._router.getCurrentNavigation().extras.state;
    this.getDataFromRoute(state);
  }

  getDataFromRoute(state) {
    if (state === undefined) {
      return;
    }

    if (state.hasOwnProperty('title')) {
      this.errorTitle = state.title;
    }

    if (state.hasOwnProperty('description')) {
      this.errorDescription = state.description;
    }

    if (state.hasOwnProperty('showButton')) {
      this.showButton = state.showButton;
    }

    if (state.hasOwnProperty('textButton')) {
      this.textButton = state.textButton;
    }

    if (state.hasOwnProperty('pathButton')) {
      this.pathButton = state.pathButton;
    }
  }

  toLogin() {
    this._router.navigate([this.pathButton], {relativeTo: this.activatedRoute.parent});
  }

  ngOnInit() {}
}
